import { useState } from "react";
import { IonText } from "@ionic/react";
import { ExportRequests } from "components/Molecules";
import { Alert } from "swing-components";
import { generateSwingSupportURL } from "swing-utils";

import { COMBINED_RESTRICTIONS, translate, useShouldRestrictAdmin } from "~utils";

import { RequestType } from "./RequestIndex";

export function RequestsHeader(props: { requestType: RequestType }) {
  const [exportSuccessful, setExportSuccessful] = useState<boolean | undefined>(undefined);
  const hideCSVExportRequest = useShouldRestrictAdmin([COMBINED_RESTRICTIONS.VIEW_SUB_PAY]);

  return (
    <section className="mw-800">
      <div
        css={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          alignItems: "center",
        }}
      >
        <h1 css={{ margin: "16px 0" }}>
          {props.requestType === "active-requests"
            ? translate("ROUTE_TABLE_ACTIVE_REQUESTS")
            : translate("ROUTE_TABLE_PAST_REQUESTS")}
        </h1>
        <div className="ion-hide-lg-down">
          {!hideCSVExportRequest && (
            <ExportRequests
              requestType={props.requestType}
              onSuccess={() => setExportSuccessful(true)}
              onFailure={() => setExportSuccessful(false)}
            />
          )}
        </div>
      </div>
      {exportSuccessful === false && (
        <div className="pt-8 pb-4 w-full">
          <Alert
            showIcon
            color="danger"
            title={translate("EXPORT_REQUEST_ERROR_LABEL")}
            onDismiss={() => {
              setExportSuccessful(undefined);
            }}
          >
            <span>
              {translate("LABEL_CONTACT_SUPPORT_1")}{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={generateSwingSupportURL("/hc/en-us/requests/new")}
              >
                {translate("LABEL_CONTACT_SUPPORT")}
              </a>{" "}
              {translate("LABEL_CONTACT_SUPPORT_2")}
            </span>
          </Alert>
        </div>
      )}
      {exportSuccessful && (
        <Alert
          showIcon
          color="success"
          title={translate("EXPORT_REQUEST_SUCCESS_LABEL")}
          onDismiss={() => {
            setExportSuccessful(undefined);
          }}
          css={{ width: "100%" }}
        >
          <IonText className="text-base">{translate("EXPORT_REQUEST_SUCCESS_MSG")}</IonText>
        </Alert>
      )}
    </section>
  );
}
